/*
* @描述: 公式设置表单组件
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2024-11-04 11:21:23
*/
<template>
    <el-dialog :close-on-click-modal="false"
               :close-on-press-escape="false"
               :visible.sync="dialogVisible"
               title="编辑计算公式"
               width="680px"
               @close="handleClickFormulaEditCancel">
        <div class="formula_edit_box">
            <el-form ref="fieldForm"
                     :model="formulaForm"
                     label-position="top"
                     size="small">
                <el-form-item label="计算公式">
                    <div class="textarea_outer_wrap">
                        <span class="placeholder">计算公式=</span>
                        <div ref="textarea_div"
                             class="textarea_wrap"
                             contenteditable
                             @input="handleTextareaInput"
                             @keydown="handleTextareaKeyDown">
                        </div>
                        <img alt="" class="delete_btn"
                             src="https://download.hecoos.com/enlightv/2023-31/WXCTpjXDpzGnejYZe2tY.png"
                             @click="handleClickDel">
                        <span class="clear_btn" @click="handleClickClearFormula">清空</span>
                    </div>
                    <p class="hint">数字可直接输入，计算逻辑要符合计算规则</p>
                </el-form-item>
                <el-form-item>
                <span slot="label">
                    <span>控件</span>
                    <el-tooltip content="只可以选择数字、金额。"
                                effect="dark"
                                placement="top"
                                style="margin-left: 8px">
                        <i class="el-icon-info"></i>
                    </el-tooltip>
                </span>
                    <ul class="components_list">
                        <li v-for="item in components_list"
                            class="components_item"
                            @click="handleClickComponentsItem(item)"
                            v-text="item.new_field_name">
                        </li>
                    </ul>
                </el-form-item>
                <el-form-item label="符号">
                    <ul class="components_list">
                        <li v-for="item in symbolList"
                            class="components_item"
                            @click="handleClickSymbolItem(item)"
                            v-text="item.value">
                        </li>
                    </ul>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" align="right">
            <el-button size="small" @click="handleClickFormulaEditCancel">取消</el-button>
            <el-button size="small" type="primary" @click="handleClickFormulaEditConfirm">确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
    export default {
        name: "FormulaEditForm",
        data() {
            return {
                formulaForm: {},
                formula_items: [],
                keyCodeList: [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105],
                symbolList: [
                    {value: '+'},
                    {value: '-'},
                    {value: '*'},
                    {value: '/'},
                    {value: '('},
                    {value: ')'},
                    {value: '.'},
                    // {value: '%'},
                ],
            }
        },
        props: {
            dialogVisible: {
                type: Boolean,
                default: false
            },
            components_list: {
                type: Array,
                default: () => []
            },
            formula_list: {
                type: Array,
                default: () => []
            },
            field_form: {
                type: String,
                default: ''
            },
            now_field_key: {
                type: String,
                default: ''
            },
        },
        created() {

        },
        mounted() {
            if (this.formula_list && this.formula_list.length) {
                this.formula_items = this.formula_list
                this.$nextTick(() => {
                    this.$refs.textarea_div.innerText = ''
                    this.formula_items.forEach(item => {
                        this.creatFormulaTag(item)
                    })
                })
            }
        },
        methods: {
            //公式输入框输入事件
            handleTextareaInput(event) {
                const regex = /[\u4E00-\u9FFFa-zA-Z~!@#$%^&*()_+\-=[\]{}|\\;:'",.<>/?]/;
                if (regex.test(event.data)) {
                    if (event.data) {
                        this.$refs.textarea_div.innerText = ''
                        this.formula_items.forEach(item => {
                            this.creatFormulaTag(item)
                        })
                    }
                } else {
                    if (this.formula_items.length > 0 && this.formula_items[this.formula_items.length - 1].type === 'number') {
                        const last = this.formula_items[this.formula_items.length - 1]
                        last.content += event.data
                    } else {
                        const number = {
                            type: 'number',
                            content: event.data,
                            field_key: '',
                        }
                        this.formula_items.push(number);
                    }
                }
            },

            //监听输入框键盘事件
            handleTextareaKeyDown(e) {
                if (this.keyCodeList.indexOf(e.keyCode) < 0) {
                    e.preventDefault()
                }
            },

            //点击控件
            handleClickComponentsItem(item) {
                const component = {
                    type: 'component',
                    content: item.new_field_name,
                    field_key: item.field_key,
                    field_type: item.field_type,
                    p_field_key: item.p_field_key,
                    p_field_type: item.p_field_type,
                }
                this.formula_items.push(component);
                this.creatFormulaTag(component);
            },

            //点击符号
            handleClickSymbolItem(item) {
                const symbol = {
                    type: 'symbol',
                    content: item.value,
                    field_key: '',
                }
                this.formula_items.push(symbol);
                this.creatFormulaTag(symbol)
            },

            //创建公式标签
            creatFormulaTag(item) {
                const tag = document.createElement('span');
                tag.style.lineHeight = '22px';
                tag.style.padding = '2px 8px';
                tag.style.background = '#EDF0F4';
                tag.style.margin = '0 2px 10px';
                tag.style.borderRadius = '2px';
                item.type === 'number' ? tag.className = '' : tag.className = 'formula_item'; // 添加 CSS 类名
                tag.textContent = item.content; // 设置元素文本内容
                // tag.dataset.item = JSON.stringify(item); // 设置自定义数据属性，值为 item 对象的 JSON 字符串
                this.$refs.textarea_div.appendChild(tag); // 将新创建的元素添加到 textarea_div 中
                tag.addEventListener('click', event => {
                    event.preventDefault(); // 取消默认行为，阻止光标聚焦在 <span> 标签上
                    this.changeRange()
                });
                this.changeRange()
            },

            //重新设置鼠标焦点位置
            changeRange() {
                const nextTextNode = new Text('\u200b'); // 创建一个包含 0 宽字符（零宽度空格）的文本节点
                this.$refs.textarea_div.appendChild(nextTextNode); // 将 0 宽字符文本节点添加到 textarea_div 中
                this.$refs.textarea_div.focus(); // 输入框获得焦点
                const range = new Range(); // 创建一个 range 对象
                const selection = window.getSelection(); // 获取当前窗口的选区对象
                range.setStart(nextTextNode, 1); // 设置 range 的起始位置为 0 宽字符之后的第一个字符
                range.setEnd(nextTextNode, 1); // 设置 range 的结束位置为 0 宽字符之后的第一个字符
                selection.removeAllRanges(); // 移除所有的选区范围
                selection.addRange(range); // 将刚刚创建的 range 对象添加到选区中
            },

            //删除公式
            handleClickDel() {
                if (this.field_form === 'purchases' && this.formula_items.length === 1 && this.now_field_key === 'pay_total_price') return false
                if (this.formula_items.length > 0) {
                    this.formula_items.pop()
                    this.$refs.textarea_div.innerText = ''
                    this.formula_items.forEach(item => {
                        this.creatFormulaTag(item)
                    })
                }
            },

            //清空公式
            handleClickClearFormula() {
                if (this.formula_items.length > 0) {
                    this.$confirm('确定清空公式？', '清空提示', {
                        closeOnPressEscape: false,
                        closeOnClickModal: false,
                        type: 'warning',
                    }).then(() => {
                        if (this.now_field_key === 'pay_total_price') {
                            this.formula_items = [
                                {
                                    type: "component",
                                    content: "采购总金额",
                                    field_key: "total_price",
                                    field_type: "compute_mode",
                                    p_field_key: ""
                                }
                            ]
                            this.$refs.textarea_div.innerText = ''
                            this.formula_items.forEach(item => {
                                this.creatFormulaTag(item)
                            })
                        } else {
                            this.formula_items = []
                            this.$refs.textarea_div.innerText = ''
                        }
                    }).catch(() => {
                        return false
                    })
                }
            },

            //提交
            onClickEditConfirm() {

            },

            //公式设置取消事件
            handleClickFormulaEditCancel() {
                this.$emit('update:dialogVisible', false)
            },

            //公式设置确定事件
            handleClickFormulaEditConfirm() {
                if (this.formula_items.length === 0) return this.$message.error('请设置计算公式')
                let formula = ''
                let field_formula = ''
                this.formula_items.forEach(item => {
                    formula += item.content
                    field_formula += item.field_key ? item.field_key : item.content
                })
                this.$emit('confirm', {
                    formula,
                    field_formula,
                    formula_items: this.formula_items
                })
                this.formula_items = []
                this.$emit('update:dialogVisible', false)
            },
        },
    }
</script>
<style lang="scss" scoped>
  .formula_edit_box {
    width: 100%;

    ::v-deep .el-form-item .el-form-item__label {
      font-weight: 500;
    }

    .textarea_outer_wrap {
      position: relative;
      height: 171px;
      border: 1px solid #D9D9D9;
      border-radius: 2px;

      .placeholder {
        position: absolute;
        top: 12px;
        left: 12px;
        line-height: 22px;
      }

      .delete_btn {
        position: absolute;
        bottom: 10px;
        right: 50px;
        cursor: pointer;
        line-height: 22px;
      }

      .clear_btn {
        color: #E44144;
        position: absolute;
        bottom: 8px;
        right: 12px;
        cursor: pointer;
        line-height: 22px;
      }
    }

    .components_list {
      display: flex;
      flex-wrap: wrap;

      .components_item {
        line-height: 22px;
        padding: 0 8px;
        background: #EDF0F4;
        cursor: pointer;
        border-radius: 2px;
        text-indent: 0;
      }
    }

    .textarea_wrap {
      padding: 12px;
      height: 145px;
      color: #666666;
      overflow-y: auto;
      text-indent: 5em;
      line-height: 22px;

      &:hover {
        border-color: #C0C4CC;
      }

      &:focus {
        outline: 0;
        border-color: #1990ff;
      }

      span {
        text-indent: 0;
      }

      .formula_item {
        line-height: 22px;
        padding: 0 6px;
        background: #EDF0F4;
        margin: 0 2px 10px;
        cursor: pointer;
        border-radius: 2px;
      }
    }

    .hint {
      line-height: 18px;
      font-size: 12px;
      color: #666666;
      margin-top: 2px;
    }
  }
</style>